/**
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/CSS_Typed_OM_API#browser_compatibility Compatibility}
 *
 * @see {@link https://developer.chrome.com/blog/cssom/#browser-support-feature-detection CSSOM}
 */
export default function polyfillCSS(window) {
  if (!window.CSS) {
    window.CSS = CSS;
  }

  [
    { funcName: 'px', unit: 'px' },
    { funcName: 'percent', unit: '%' },
  ].forEach(({ funcName, unit }) => {
    if (
      !window.CSS[funcName] ||
      window.CSS[funcName](1.1).toString() !== '1.1' + unit
    ) {
      window.CSS[funcName] = (value) => {
        const numberValue = Number(value);
        if (!Number.isFinite(numberValue)) {
          throw new TypeError(
            `Failed to execute '${funcName}' on 'CSS': The provided double value is non-finite.`,
          );
        }
        return CSS(numberValue, unit);
      };
    }
  });

  function CSS(value, unit) {
    return {
      value,
      unit,
      valueOf() {
        return this.value;
      },
      toString() {
        return `${this.value}${this.unit}`;
      },
      mul(multiplier) {
        return CSS(value * multiplier, unit);
      },
    };
  }
}
